import React from 'react';

const featuredPosts = [
  {
    title: "10 Essential E-commerce Trends for 2024",
    excerpt: "Stay ahead of the curve with these key e-commerce trends shaping the industry.",
    image: "/placeholder.svg?height=400&width=600",
    category: "Trends",
    date: "Mar 15, 2024",
  },
  {
    title: "Maximizing Conversions: The Art of Product Page Optimization",
    excerpt: "Learn how to create high-converting product pages to improve customer experience.",
    image: "/placeholder.svg?height=400&width=600",
    category: "Optimization",
    date: "Mar 10, 2024",
  },
];

export function FeaturedPosts() {
  return (
    <section className="mb-12">
      <h2 className="text-2xl font-semibold mb-6">Featured Posts</h2>
      <div className="grid md:grid-cols-2 gap-6">
        {featuredPosts.map((post, index) => (
          <div key={index} className="overflow-hidden bg-white shadow-lg rounded-lg">
            <img
              src={post.image}
              alt={post.title}
              width={600}
              height={400}
              className="w-full h-48 object-cover"
            />
            <div className="p-4">
              <span className="inline-block bg-gray-200 text-gray-700 text-xs font-semibold px-2 py-1 rounded-md mb-2">
                {post.category}
              </span>
              <h3 className="text-xl font-semibold mb-2">{post.title}</h3>
              <p className="text-gray-600">{post.excerpt}</p>
            </div>
            <div className="px-4 py-3 bg-gray-100 text-sm">
              {post.date}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
